import { render, staticRenderFns } from "./Active.vue?vue&type=template&id=d5125bf8&scoped=true"
import script from "./Active.vue?vue&type=script&lang=js"
export * from "./Active.vue?vue&type=script&lang=js"
import style0 from "./Active.vue?vue&type=style&index=0&id=d5125bf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5125bf8",
  null
  
)

export default component.exports